/**
 * @module utils/inherits
 */

const { isPrototypeOf } = Object

/**
 * A function to test if an object inherits from another one
 * @param {{}}target
 * @param {{}|null}parent
 * @returns {Boolean}
 */
export default (target, parent) => {
  return isPrototypeOf.call(parent, target)
}
